import React, { useCallback } from "react";
import useReactRouter from "use-react-router";

import { FullSite } from "../../../../dtos/site";
import { ResponsiveDataView, Column } from "../../../shared/ResponsiveDataView";

interface Props {
    sites: FullSite[];
    dealerId: number | null;
    linkRowToSiteAlarms?: boolean;
}

export function SitesTable({
    sites,
    dealerId,
    linkRowToSiteAlarms = false
}: Props) {
    const { history } = useReactRouter();

    const goToSiteAlarms = useCallback((site: FullSite) => {
        history.push(`/dealers/${dealerId}/organizations/${site.organizationId}/sites/${site.id}/alarms`, {
            // Pass null date filters to show ALL alarms (not just last 30 days)
            // and only show unacknowledged alarms
            from: null,
            to: null,
            showOnlyUnacknowledged: true,
        });
    }, [history, dealerId]);

    const columns: Column<FullSite>[] = [
        { key: 'uniqueSiteId', label: 'Id' },
        { key: 'name', label: 'Site Name', primary: true },
        {
            key: 'acsVersion',
            label: 'Version',
            render: (s) => (
                <span style={{ wordWrap: "break-word", maxWidth: "100px", display: 'inline-block' }}>
                    {s.acsVersion}
                </span>
            ),
        },
    ];

    return (
        <ResponsiveDataView
            rows={sites}
            columns={columns}
            rowKey={(s) => s.id}
            onRowClick={linkRowToSiteAlarms ? goToSiteAlarms : undefined}
        />
    );
}
